import { gql } from "@apollo/client";

export const GET_PRINT_INFORME_PACIENTE = gql`
query printInformeAsistencialPaciente($html: String!) {
    printInformeAsistencialPaciente(html: $html)
}`;